import { defineElement, FC, useElement, useElements, useListen } from '@atomify/hooks';

const FAQ_ACCORDEON_ITEM = '.accordeon-item__subitem';
const FAQ_CONTENT_COLLAPSE = 'bpd-content-collapse';
const HIDDEN_CLASS = 'u-hidden';
const EXPANDED_ATTR = 'expanded';

const Faq: FC = () => {
    const input = useElement<HTMLInputElement>('[js-hook-faq-input]');
    const items = useElements<HTMLDivElement[]>('[js-hook-faq-items] > div');

    useListen(input, 'input', onInput);

    function onInput(e: InputEvent) {
        const { value } = e.currentTarget as HTMLInputElement;
        toggleResults(value);
    }

    function toggleResults(val: string) {
        const itemArray = items.current as HTMLDivElement[];

        if (val) {
            itemArray.forEach((item) => {
                const content = item.querySelector(FAQ_CONTENT_COLLAPSE);
                const subItems = Array.from(
                    item.querySelectorAll(FAQ_ACCORDEON_ITEM),
                ) as HTMLDivElement[];
                if (!content) return;

                if (!item.innerText.toLowerCase().includes(val.toLowerCase())) {
                    item.classList.add(HIDDEN_CLASS);
                    content.removeAttribute(EXPANDED_ATTR);
                } else {
                    item.classList.remove(HIDDEN_CLASS);
                    content.setAttribute(EXPANDED_ATTR, '');

                    Array.from(item.children).forEach((item: HTMLElement) => {
                        const subItems = Array.from(
                            item.querySelectorAll(FAQ_ACCORDEON_ITEM),
                        ) as HTMLDivElement[];

                        if (!subItems.length) {
                            item.innerHTML = removeHighlight(item);
                            item.innerHTML = addHighlight(item, val);
                        }
                    });
                }

                if (subItems.length) {
                    subItems.forEach((subItem) => {
                        const subItemContent = subItem.querySelector(FAQ_CONTENT_COLLAPSE);
                        if (!subItemContent) return;

                        if (!subItem.innerText.toLowerCase().includes(val.toLowerCase())) {
                            subItem.classList.add(HIDDEN_CLASS);
                            subItemContent.removeAttribute(EXPANDED_ATTR);
                        } else {
                            subItem.classList.remove(HIDDEN_CLASS);
                            subItemContent.setAttribute(EXPANDED_ATTR, '');

                            subItem.innerHTML = removeHighlight(subItem);
                            subItem.innerHTML = addHighlight(subItem, val);
                        }
                    });
                }
            });
        } else {
            itemArray.forEach((item) => {
                const content = item.querySelector(FAQ_CONTENT_COLLAPSE);
                const subItems = Array.from(
                    item.querySelectorAll(FAQ_ACCORDEON_ITEM),
                ) as HTMLDivElement[];
                if (!content) return;

                item.classList.remove(HIDDEN_CLASS);
                content.removeAttribute(EXPANDED_ATTR);

                if (!subItems.length) item.innerHTML = removeHighlight(item);

                if (subItems.length) {
                    subItems.forEach((subItem) => {
                        const subItemContent = subItem.querySelector(FAQ_CONTENT_COLLAPSE);
                        if (!subItemContent) return;

                        subItem.classList.remove(HIDDEN_CLASS);
                        subItemContent.removeAttribute(EXPANDED_ATTR);

                        subItem.innerHTML = removeHighlight(subItem);
                    });
                }
            });
        }

        /**
         * escape regex
         */
        function escapeRegExp(string: string) {
            return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        }

        /**
         * Add <mark> tag to matching values
         */
        function addHighlight(el: HTMLElement, val: string) {
            return el.innerHTML.replace(
                new RegExp(`(?<!<\/?[^>]*|&[^;]*)(${escapeRegExp(val)})`, 'gi'),
                (match) => `<mark>${match}</mark>`,
            );
        }

        /**
         * Remove <mark> tags
         */
        function removeHighlight(el: HTMLElement) {
            return el.innerHTML.replace(/(<mark>|<\/mark>)/g, '');
        }
    }
};

defineElement('bpd-faq', Faq);
